const currentVersion = '4.1.0';
export function formatActionEvent(sideEffectsData, captured) {
    return {
        BusinessUnit: captured.businessUnit,
        Name: 'Action',
        Version: currentVersion,
        EventData: [
            {
                BrowserTimestamp: sideEffectsData.browserTimestamp,
                PageId: sideEffectsData.pageId,
                SessionId: sideEffectsData.sessionId,
                TrackingId: sideEffectsData.trackingId,
                UserAgent: sideEffectsData.userAgent || null,
                Page: captured.page || null,
                Section: captured.section || null,
                Component: captured.component || null,
                Element: captured.element || null,
                Initiator: captured.initiator || null,
                InteractionType: captured.interactionType || null,
                EventDetails: upperCaseKeys(captured.eventDetails) || null,
                BookingId: captured.bookingId || null,
                ZlogRollupBucket: captured.zlogRollupBucket,
                ZlogPageType: captured.zlogPageType,
                Category: captured.category,
                Action: captured.action,
                Label: captured.label,
                Value: captured.value,
                /**
                 * If the user is defining GA data, build the Name field according to
                 * GA legacy event: [Category] Action
                 *
                 * If the user is not defining GA data, build the name field according to the
                 * GA "derived from PEDL" event: [Section] [Component] [Element] InteractionType
                 */
                Name: captured.action
                    ? brackets(captured.category) + (captured.action || '')
                    : brackets(captured.section) +
                        brackets(captured.component) +
                        brackets(captured.element) +
                        (captured.interactionType || ''),
            },
        ],
    };
}
/**
 * This function warns the user if the metric does not conform to the
 * defined schema. It only warns if in development environment
 */
export function validateActionMetric(metric) {
    if (process.env.NODE_ENV === 'development') {
        if (!metric.BusinessUnit ||
            !metric.Name ||
            !metric.Version ||
            !metric.EventData) {
            console.warn('METRIC SCHEMA ERROR: fields BusinessUnit, Name, Version, and EventData are required.');
        }
        if (metric.Name === 'Action' && metric.Version === currentVersion) {
            const { EventData } = metric;
            EventData.forEach(e => {
                if (!e.BrowserTimestamp ||
                    !e.PageId ||
                    !e.SessionId ||
                    !e.TrackingId ||
                    !e.UserAgent) {
                    console.warn('METRIC SCHEMA ERROR: [side effects data] fields BrowserTimestamp, PageId, SessionId, TrackingId, and UserAgent are required.');
                }
                if (!e.Page ||
                    !e.Section ||
                    !e.Component ||
                    !e.Element ||
                    !e.Initiator ||
                    !e.InteractionType
                // EventDetails is not required
                ) {
                    console.warn('METRIC SCHEMA ERROR: [PEDL data] fields Page, Section, Component, Element, Initiator, and InteractionType are required.');
                }
            });
        }
    }
}
export function formatGaLegacy(metric) {
    const eventData = metric.EventData[0];
    return {
        hitType: 'event',
        eventCategory: eventData.Category,
        eventAction: brackets(eventData.Category) + (eventData.Action || ''),
        eventLabel: eventData.Label,
        eventValue: eventData.Value,
    };
}
export function formatGaFromPedl(metric) {
    const eventData = metric.EventData[0];
    return {
        hitType: 'event',
        eventCategory: eventData.Page,
        eventAction: brackets(eventData.Section) +
            brackets(eventData.Component) +
            brackets(eventData.Element) +
            (eventData.InteractionType || ''),
    };
}
function brackets(x) {
    return x ? `[${x}] ` : '';
}
export function upperCaseKeys(obj) {
    return (obj &&
        Object.keys(obj).reduce((acc, key) => {
            const upperCasedKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (acc === null) {
                return { [upperCasedKey]: obj[key] };
            }
            else {
                acc[upperCasedKey] = obj[key];
                return acc;
            }
        }, {}));
}
